module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en-us":{"errors":{"loadCountryOptions":"Something went wrong and we couldn\u0027t load the country options. Please try again."},"recurring":{"end":"End payments","start":"Created date","next":"Next payment"}}}')
  delete Component.options._Ctor
}
